<template>
    <div id="app">
        <div class="header">
            <div class="search">
                <input type="text" class="search-inp" v-model="search_val" placeholder="请输入姓名" name="" id="" value=""
                       @keyup.enter="search"/>
                <el-button type="success" @click="search" icon="el-icon-search"></el-button>
            </div>
            <span class="look" style="display: block;padding-left:0px;" @click="look_class">查看选课</span>
        </div>

        <div class="left_content">
            <div class="thead">会员信息</div>
            <el-table
                    :data="tableData"
                    @row-click="rowClick"
                    :header-cell-style="{background:'#f5f6fa'}"
                    highlight-current-row>

                <el-table-column
                        property="baobao_name"
                        label="姓名"
                        width="120">
                </el-table-column>
                <el-table-column
                        property="baobao_name2"
                        label="别名"
                        width="120">
                </el-table-column>
                <el-table-column
                        property="yueling"
                        label="月龄">
                </el-table-column>
                <el-table-column
                        label="家长姓名">
                    <template slot-scope="scope">
                        <span>{{ scope.row.name ? scope.row.name : '--' }}</span>
                    </template>
                </el-table-column>
            </el-table>

            <div class="thead" style="border-left: 4px solid #7ac4c7;margin-top: 50px;">已选课程</div>
            <el-table
                    :data="tableData3"
                    :header-cell-style="{background:'#f5f6fa'}"
                    highlight-current-row>

                <el-table-column
                        property="kc_name"
                        label="课程/班级名称"
                        width="120">
                </el-table-column>
                <el-table-column
                        property="start_time"
                        label="课程开始日期"
                        width="120">
                </el-table-column>
                <el-table-column
                        label="上课时间">
                    <template slot-scope="scope">
                        <p>星期{{ tmp_week[scope.row.week]}}{{scope.row.s_time}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        property="content"
                        label="教室">
                </el-table-column>
                <el-table-column
                        label="状态">
                    <template slot-scope="scope">
                        <el-button
                                size="mini"
                                type="success" @click="move_class(scope.row.pk_id,scope.row.bao_id)">取消班级
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="right_content">
            <div class="thead" style="">
                可选课程
                <el-button size="mini" round class="boxshadow " style="margin-left: 30px"
                           :class="{activex:(xuan==indexr+1)}" @click="search_time(indexr+1,itemr.start_time)"
                           v-for="(itemr,indexr) in tmp_round" :key="indexr">{{itemr.start_time}} -- {{itemr.end_time}}
                </el-button>
            </div>
            <el-table
                    :data="tableData2"
                    :header-cell-style="{background:'#f5f6fa'}"
                    highlight-current-row>

                <el-table-column
                        property="kc_name"
                        label="课程/班级名称"
                        width="120">
                </el-table-column>
                <el-table-column
                        property="start_time"
                        label="课程开始日期"
                        sortable
                        width="140">
                </el-table-column>
                <el-table-column
                        label="上课时间">
                    <template slot-scope="scope">
                        <p>星期{{ tmp_week[scope.row.week]}}{{scope.row.s_time}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        property="content"
                        label="教室">
                </el-table-column>
                <el-table-column
                        label="状态">
                    <template slot-scope="scope">
                        <el-button
                                size="mini"
                                type="success" @click="add_class(scope.row.pk_id,scope.row.bao_id)">加入该班
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                tokenVal: '',
                tableData: [],//表格数据
                tableData2: [],
                tableData3: [],
                search_val: '',//搜索内容
                b_id: '',
                b_name: '',//会员姓名
                rows: '',
                p_id: '',
                tmp_week: ['', '一', '二', '三', '四', '五', '六', '日',],
                tmp_round: [],   //周期列表
                now_round: '',    //当前选择周期
                xuan: '',
            }
        },
        methods: {
            //查看选课
            look_class() {
                this.$router.push({path: './look_class'})
            },
            //排课周期筛选
            search_time(xuan, start_time) {
                this.xuan = xuan;
                this.now_round = start_time
                //判断是否选择过宝宝
                if (this.p_id) {
                    this.search_id()
                } else {
                    this.search()
                }
            },
            //搜索
            search() {
                let that = this
                $.ajax({
                    url: process.env.apiUrl + 'saas/paike/selects',
                    type: 'post',
                    data: {
                        name: that.search_val,
                        token: that.tokenVal,
                        start_time: that.now_round
                    },
                    dataType: "json",
                    success: function (data, status) {
                        if (data == '') {
                            alert('暂无数据')
                        } else {
                            that.tableData = data.data
                            // that.tableData2 = data.ke
                            // that.tableData3 = data.yi
                            that.tableData2 = []
                            that.tableData3 = []
                        }
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },
            //获取当前两条排课周期
            get_round() {
                let that = this
                $.ajax({
                    url: process.env.apiUrl + 'saas/paike/get_round',
                    type: 'post',
                    data: {
                        token: that.tokenVal
                    },
                    dataType: "json",
                    success: function (data) {
                        if (data.status == 2) {
                            that.tmp_round = [];
                        } else {
                            that.tmp_round = data.data;
                        }
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },
            //会员信息点击事件
            rowClick(row, event, column) {
                this.p_id = row.user_id
                this.b_name = row.baobao_name
                this.search_id()
            },
            search_id() {
                let that = this
                $.ajax({
                    url: process.env.apiUrl + 'saas/paike/selects',
                    type: 'post',
                    data: {
                        name: that.b_name,
                        id: that.p_id,
                        start_time: that.now_round,
                        token: that.tokenVal
                    },
                    dataType: "json",
                    success: function (data, status) {
                        that.tableData2 = data.ke
                        that.tableData3 = data.yi
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },
            //加入该班
            add_class(p_id, b_id) {
                let that = this
                $.ajax({
                    url: process.env.apiUrl + 'saas/paike/selects',
                    type: 'post',
                    data: {
                        id: b_id,
                        pk_id: p_id,
                        name: that.b_name,
                        token: that.tokenVal
                    },
                    dataType: "json",
                    success: function (data, status) {
                        that.add_success(data.msg);
                        that.search_id()
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },
            //添加成功
            add_success(msg) {
                alert(msg);
                return;
                this.$alert(msg, '通知', {
                    confirmButtonText: '确定',
                    callback: action => {
                    }
                });
            },
            //取消该班型
            move_class(p_id, b_id) {
                let that = this
                $.ajax({
                    url: process.env.apiUrl + 'saas/paike/selects',
                    type: 'post',
                    data: {
                        q_id: p_id,
                        id: b_id,
                        name: that.b_name,
                        token: that.tokenVal
                    },
                    dataType: "json",
                    success: function (data, status) {
                        that.move_success();
                        that.search_id()
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },
            move_success() {
                this.$message({
                    message: '已取消该固定班级',
                    type: 'success'
                });
            }
        },
        mounted: function () {
            let self = this
            self.tokenVal = self.$cookies.get("token")
            self.get_round()
        }
    }
</script>

<style scoped="scoped" lang="less">
    #app {
        padding: 20px;
    }

    .activex {
        color: #8CBB77;
        border-color: #8CBB77;
    }

    .header {
        text-align: center;
        margin-bottom: 15px;
        .search {
            display: inline-block;
            position: relative;
            .search-inp {
                width: 192px;
                height: 30px;
                border-radius: 14px 0 0 14px;
                border: 1px solid #8CBB77;
                padding-left: 18px;
                outline: none;
            }
            .el-button {
                padding: 8px;
                background-color: #8CBB77;
                border-radius: 0 14px 14px 0;
                position: absolute;
                top: -1px;
                right: -31px;
                cursor: pointer;
                border-color: white;
            }
        }
        .look {
            color: white;
            cursor: pointer;
            letter-spacing: 3px;
            float: right;
            width: 90px;
            font-size: 14px;
            height: 26px;
            line-height: 26px;
            text-align: center;
            margin-right: 3%;
            background: #8CBB77;
            border-radius: 13px;
        }
    }

    .left_content {
        width: 45%;
        float: left;
        .thead {
            border-left: 4px solid #8CBB77;
            margin-top: 15px;
            margin-bottom: 10px;
            height: 25px;
            line-height: 25px;
            font-size: 18px;
            padding-left: 12px;
        }
        .el-table {
            border: 1px solid #dbdbdb;
            border-radius: 3px;
            thead {
                color: black;
            }
        }
    }

    .right_content {
        width: 50%;
        float: right;
        border-left: 1px solid #e4e4e4;
        padding-left: 32px;
        margin-top: 10px;
        .thead {
            border-left: 4px solid #fdb06a;
            margin-bottom: 10px;
            margin-top: 5px;
            height: 25px;
            line-height: 25px;
            font-size: 18px;
            padding-left: 12px;
        }
        .el-table {
            border: 1px solid #dbdbdb;
            border-radius: 3px;
            thead {
                color: black;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/xuanke/select_class.vue